import { Component, Input, OnChanges, TemplateRef, Inject } from '@angular/core';
import { ChatService } from 'src/app/core/services/chat.service';
import { Location } from '@angular/common';
import { CommonService } from '../../core/services/common.service';
import { QueryStringService } from '../../core/services/query-string.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.less']
})
export class LinkComponent implements OnChanges {
  @Input() public externalLink: string | null | undefined = '';
  @Input() public internalLink: string | null | undefined = '';
  @Input() public documentLink: string | null | undefined = '';
  @Input() public target: string | null | undefined = '';
  @Input({ required: true }) public childClass = '';
  @Input({ required: true }) public linkTitle = '';
  @Input() public linkContent: TemplateRef <any> | null | undefined;
  @Input() public chatLink: boolean | null | undefined = false;
  @Input() public fragment: string | undefined = '';
  public pathName = '';

  constructor(private chatService: ChatService,
    private location: Location,
    private commonService: CommonService,
    private queryStringService: QueryStringService,
    @Inject(DOCUMENT) private dom: Document) {
  }
  
  triggerChat() {
    this.chatService.chatButtonClick.next(true);
  }

  ngOnChanges(): void {
    if (this.commonService.isPlatformBrowser()) {
      this.appendQueryParamsToLink();
    }

    if (this.location.path()) {
      this.pathName = this.location.path().split(/[#?]/)[0];
    }
  }

  private appendQueryParamsToLink(): void {
    // Store the query params as a string
    const existingURLSearchParams = new URLSearchParams(this.dom.location.search);
    const siteQueryParams = Object.fromEntries(existingURLSearchParams.entries());
    let queryParams = this.queryStringService.sanitizeParams(siteQueryParams);
    queryParams = new URLSearchParams(this.queryStringService.removeBlackListedParams(queryParams)).toString();

    if (queryParams && queryParams.length > 0) {
      if (this.externalLink?.startsWith("http")) {
        let [externalLink, fragment] = this.externalLink.split('#');
        // * - If the `externalLink` starts with "http", it appends the sanitized query parameters to the link.
        // * - If the `externalLink` contains a fragment (indicated by '#'), it ensures the fragment is preserved after appending the query parameters.
        externalLink += (externalLink.includes('?') ? '&' : '?') + queryParams;
        if (fragment) {
          externalLink += '#' + fragment;
        }

        this.externalLink = externalLink;
      }
    }
  }
}
